import { render, staticRenderFns } from "./AddSubTagModal.vue?vue&type=template&id=79dab3ae"
import script from "./AddSubTagModal.vue?vue&type=script&lang=js"
export * from "./AddSubTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports